// extracted by mini-css-extract-plugin
module.exports = {"iframe":"fulladia_iframe__yUyvF"};